import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import bg1 from '../assets/bg1.jpg'
import { Link } from 'react-router-dom'
import { finanseItems, dlaczegoItems } from '../components/HomeItems'
import {BsFillArrowDownCircleFill} from 'react-icons/bs'
import {Link as Scroll} from 'react-scroll'


function Home() {

  return (
    <>
        <Navbar />
          
          <div className='pt-20 flex justify-center mx-auto static'>
              <div className='bg-white bg-opacity-90 absolute mx-auto justify-center mt-20 max-w-[400px] text-center py-5 rounded-xl px-2'>
                <h3 className='uppercase text-xl md:text-3xl font-semibold'>Nasze motto</h3>
                <p className='pb-2'>Dlaczego frma konsulingowa <b>ONIKO-EXPERT</b>?</p>
                <p>Nie można znać się na wyszystkim ale można wiedzieć gdzie się z tym wszystkim udać. Jeśli czegoś nie wiesz - pytaj, bo kto pyta już nie błądzi.</p>
                <Scroll to="dlaczego" spy={true} smooth={true} offset={-100} duration={500}>
                  <button className='bg-[#040dc4] text-white rounded-md py-1 px-2 hover:scale-105 duration-500 mt-4'>
                    Dlaczego my?
                  </button>
                </Scroll>
              </div>
              <img src={bg1} alt="background photo" className='w-screen h-96  object-cover'/>
          </div>  

          <div className='max-w-[1240px] bg-white mx-auto justify-center'>
            <div className='text-center mx-auto justify-center'>
                  <h1 className='pt-8 justify-center flex font-bold text-3xl md:text-6xl text-[#040dc4]'>ONIKO-EXPERT</h1>
                  <p className='py-4 justify-center flex px-10 md:px-44 text-md'>Jesteśmy rzetelną firmą zarejestrowaną w Komisji  Nadzoru Finansowego.
                  Zaufaj doświadczeniu i wiedzy naszych ekspertów.</p>
                  <div className='mx-auto grid md:grid-cols-4 grid-cols-1 gap-3 py-16'>
                    {finanseItems.map((item) => (
                      <div key={item.id} className='mx-5 bg-slate-50 px-10 py-3 rounded-lg hover:scale-105 duration-500 hover:bg-slate-100'>
                        <div className='bg-black w-20 h-20 flex mx-auto rounded-full shadow-md mb-1'>
                            <img src={item.img}  alt={item.img} className='object-cover rounded-full'/>
                        </div>
                        <h3 className='font-semibold pt-1'>
                          {item.title}
                        </h3>
                        <div className='my-1'>
                        <p className='py-4 '>
                          {item.text}
                        </p>
                        </div>
                        <div className='flex justify-center'>
                          <Link to={item.path}>
                          <button className='flex text-white items-center bg-[#040dc4] color-[#040dc4] rounded-xl py-2 px-3 hover:scale-105 duration-500 hover:shadow-md'>
                            Rozwiń
                            <BsFillArrowDownCircleFill className='ml-2 hover:scale-105 duration-300'/>
                          </button>
                          </Link>
                        </div>
                    </div>
                    ))}
                  </div>

                  <h2 id="dlaczego" className='pt-16 justify-center flex font-bold text-2xl md:text-4xl'>DLACZEGO WARTO WYBRAĆ ONIKO?</h2>  
                  
                  <div className='grid gap-4 grid-cols-1 md:grid-cols-2 py-16 px-10 md:px-36'>
                        {dlaczegoItems.map((item => (
                          <div key={item.id} className='py-2 pb-10'> 
                          <i className='flex mx-auto justify-center text-[#040dc4]'>{item.icon}</i>
                          <h3 className='font-semibold text-xl py-4'>{item.title}</h3>
                          <p className='px-1 md:px-10'>{item.text}</p>
                          </div>
                        )))}
                  </div>
                  <div className='flex justify-center pb-20'>
                    <button><Link to='/onas' className='flex text-white items-center bg-[#040dc4] color-[#040dc4] rounded-xl py-2 px-3 hover:scale-105 duration-500 hover:shadow-md'>Poznaj firmę oraz ekspertów</Link></button>
                  </div>
                  <Footer />   
            </div>
          </div>
      
    </>
  )
}

export default Home